import { useIntl } from 'react-intl'

import BookingCodesContent from './BookingCodesContent'
import BookingStatusContent from './BookingStatusContent'

export const CreateDescriptionBlocks = (key: string) => {
  const intl = useIntl()

  return [
    {
      key: 'codes',
      title: intl.formatMessage({ id: 'global.booking-codes' }),
      content: BookingCodesContent(key),
    },
    {
      key: 'status',
      title: intl.formatMessage({ id: 'global.booking-status' }),
      content: BookingStatusContent(key),
    },
  ].filter(item => item.key === key)
}
